import React from 'react';

const Card = ({ children, className = '', title, action }) => {
  return (
    <div className={`bg-sp-gray-900 border border-sp-gray-700 rounded-lg overflow-hidden flex flex-col ${className}`}>
      {(title || action) && (
        <div className="flex justify-between items-center p-4 border-b border-sp-gray-800 bg-sp-gray-800/50">
          {title && <h3 className="text-sm font-semibold tracking-wider text-gray-300 uppercase">{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="p-4 flex-grow">
        {children}
      </div>
    </div>
  );
};

export default Card;